module.exports = __webpack_public_path__ + "static/media/ico_boteria-beta.e9d4b455.svg";